import React, { useContext } from 'react';
import { Box, Tooltip, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ReactComponent as CopilotChatButton } from '../../svg/mindtickle/mt-buyer-copilot-chat-button.svg';
import { OrganizationThemeContext } from '../../lib/context/OrganizationThemeContext';

const useStyles = makeStyles((theme: Theme) => ({
  buttonContainer: {
    alignItems: 'center',
    borderRadius: theme.spacing(15),
    display: 'flex',
    height: theme.spacing(2.5),
    justifyContent: 'center',
    width: theme.spacing(2.5),
    cursor: 'pointer',
  },
}));

export interface BuyerCopilotButtonProps {
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  tooltipTitle?: string;
}

const BuyerCopilotButton: React.FC<BuyerCopilotButtonProps> = (
  props: BuyerCopilotButtonProps
) => {
  const { disabled = false, onClick, tooltipTitle = '' } = props;
  const { buttonsStyles } = useContext(OrganizationThemeContext);

  const classes = useStyles();
  return (
    <Tooltip
      title={tooltipTitle}
      placement="top"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 12],
              },
            },
          ],
        },
      }}
    >
      <Box
        onClick={onClick}
        className={classes.buttonContainer}
        sx={() => ({
          backgroundColor: disabled
            ? 'var(--buyer-copilot-disabled)'
            : buttonsStyles?.backgroundColor || 'var(--buyer-copilot-enabled)',
          '&:hover': {
            transform: disabled ? 'none' : 'scale(1.05)',
          },
        })}
      >
        <CopilotChatButton width={13} height={13} />
      </Box>
    </Tooltip>
  );
};

export default BuyerCopilotButton;
